import { useMemo } from 'react'
import { isIOS } from 'react-device-detect'
import { config } from '../components/Init/Init'
import { getOsVersion } from '../services/utils'

export const useIsCasinoLiteMode = () => {
  const getCasinoMode = () => {
    if (config.allowHybridCasinoLiteMode) {
      const osVersion = getOsVersion()

      // if osVersion was not detected the all iOs devices should use CasinoLite mode
      return osVersion ? osVersion <= config.maxIOsVersionForCasinoLiteMode : true
    }

    // if 'allowHybridCasinoLiteMode' false the all iOs devices should use CasinoLite mode
    return true
  }

  const isCasinoLiteMode = useMemo(() => {
    if (window.location.pathname.includes('game/R/') && isIOS) {
      return getCasinoMode()
    }

    return false
  }, [window.location.pathname])

  const isCasinoLiteModeWithPathIgnore = useMemo(() => {
    if (isIOS) {
      return getCasinoMode()
    }

    return false
  }, [])

  return { isCasinoLiteMode, isCasinoLiteModeWithPathIgnore }
}
